import { definePreset } from '@primeng/themes'
import Aura from '@primeng/themes/aura'
import { COLORS } from './colors.config'

export const MyPreset = definePreset(Aura, {
  semantic: COLORS,
  theme: {
    options: {
      darkModeSelector: '.dark-mode',
    },
  },
  components: {
    menubar: {
      css: `
          .p-menubar {
            border-radius: 0;
          }
          .p-menubar-button{
            padding: 1rem;
          }
          .mobile .p-menubar-end{
            width: 100%;
          }
        `,
    },
    popover: {
      css: `
          .p-popover:before, .p-popover:after {
            content: none;
          }
        `,
    },
    togglebutton: {
      css: `
          .dark-toggleButton{
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50%;
            .p-togglebutton-label{
              display: none;
            }
            .p-togglebutton.p-togglebutton-checked::before {
              background: none;
            }
          }
        `,
    },
    card: {
      css: `
          :root{
            .documents-card{
              --p-card-shadow: none;
              &.xs, &.sm, &.md{
                position: sticky;
                left: 1rem;
                .p-card-body{
                  padding: 1rem
                }
              }
            }
          }
        `,
    },
    fileupload: {
      css: `
          :root{
            .p-fileupload{
              height: 330px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .p-fileupload-content{
                display: block;
              }
              .p-button:not(.p-button-icon-only){
                width: 100%;
              }
              .p-progressbar{
                display: none;
              }
            }
            .multi-file-upload-container{
              .p-fileupload{
                min-width: 290px;
                height: 100%;
                min-height: 330px;
              }
              .p-fileupload-content{
                height: 100%;
              }
            }
          }
        `,
    },
    tag: {
      css: `
          .status, .request-fetch-error-tag, .no-result-tag{
            .p-tag-label{
              display: none;
            }
          }
          .request-status-tag{
            align-items: center;
          }
        `,
    },
    message: {
      css: `
        .requiredFileMessage{
          .p-message-content{
            justify-content: space-between;
            flex-direction: row-reverse;
          }
        }
      `,
    },
    datatable: {
      css: `
        .p-datatable-scrollable > .p-datatable-table-container{
          border-radius: var(--p-border-radius-md)!important;
          max-height: 65vh!important;
        }
      `,
    },
  },
})
